import { useQuery } from "@apollo/client";
import { QR_GET_TRIP_PUBLICATION_SUMMARY } from "../graphQl/DetailsTripAPI";

export const useTripPublicationSummary = (tripPublicationId) => {
  const { loading, error, data } = useQuery(QR_GET_TRIP_PUBLICATION_SUMMARY, {
    variables: { tripPublicationId },
    skip: !tripPublicationId,
    fetchPolicy: "cache-first",
  });

  const tripPublicationSummary = data?.QR_GET_TRIP_PUBLICATION_SUMMARY?.data;

  return {
    loading,
    error,
    tripPublicationSummary,
  };
};
